'use client';

import './styles/@theme';
import { useState, useEffect } from 'react';
import { JackpotDescription } from '@/app/components/game/subcomponents/daily-jackpot/daily-jackpot-description';
import { JackpotAmountAndTime } from '@/app/components/game/subcomponents/daily-jackpot/daily-jackpot-amount-time';
import { useGlobalContext } from '@/store/contexts/global-context';
import { PRODUCT_THROTTLES } from '@/utils/feature-flags/constants';

// TODO: Define TYPE FOR THIS
export const RedTigerHero = (props: any) => {
    const { featureFlags } = useGlobalContext();

    const jackpotContent = props.heroData?.data?.body[0]?.primary;
    const { background_image: backgroundImage, logo_image: logoImage, jackpot_id: feedsCode } = jackpotContent || {};

    const [isScrolling, setIsScrolling] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.innerWidth < 500 && document.body.scrollTop > 110) {
                setIsScrolling(true);
            } else {
                setIsScrolling(false);
            }
        };

        document.body.addEventListener('scroll', handleScroll);
        return () => {
            document.body.removeEventListener('scroll', handleScroll);
        };
    }, []);

    if (!featureFlags[PRODUCT_THROTTLES.DAILY_JACKPOTS]) {
        return null;
    }

    return (
        <section style={{ minHeight: '220px' }}>
            <div
                data-testid="jackpot-hero"
                className={isScrolling ? 'jackpot-hero__shrink' : 'jackpot-hero'}
                style={{ backgroundImage: `url(${backgroundImage?.url})` }}>
                <div className="jackpot-hero__description">
                    <img
                        src={logoImage?.url}
                        alt="daily jackpots logo"
                        loading="eager"
                        fetchPriority="high"
                        className="jackpot-hero__logo"
                    />
                    <div className={isScrolling ? 'jackpot-hero__shrink__description' : ''}>
                        <JackpotDescription
                            jackpotFromContent={jackpotContent}
                            feedsCode={feedsCode}
                            showDescription={true}
                            isJustWonState={false}
                        />
                    </div>
                </div>
                <div className="jackpot-hero__value">
                    <JackpotAmountAndTime feedsCode={feedsCode} size="S" theme="light" />
                </div>
            </div>
        </section>
    );
};
